import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import DashboardMenu from "./DashboardMenu";
import "./DashboardPage.css";

export default function Dashboard() {
  useEffect(() => {
    document.title = "Play It Creator";
  }, []);

  return (
    <div className="dashboardpage-root">
      <DashboardMenu />
      <Outlet />
    </div>
  );
}
